import { createFileRoute } from "@tanstack/react-router";

import { RouteErrorFallback } from "@/components/error-message";
import { AdminPending } from "@/features/admin/components/admin-route-components";
import { ignoredCandidatesQueryOptions } from "@/features/admin/lib/ignored-candidates-queries";
import { adminSeoHead } from "@/lib/seo";

export const Route = createFileRoute("/_app/_authenticated/admin/ignored-sources")({
  head: () => adminSeoHead("Review Decisions"),
  loader: ({ context }) =>
    context.queryClient.query({ ...ignoredCandidatesQueryOptions, staleTime: "static" }),
  pendingComponent: AdminPending,
  errorComponent: RouteErrorFallback,
});
